import { withTranslation /* , i18n */ } from 'server/i18n'
import { NextSeo } from 'next-seo'
import PropTypes from 'prop-types'
import { Box } from 'reflexbox'
import getConfig from 'next/config'
import BlockTitle from 'components/BlockTitle'

import layoutTheme from 'theme/layout-theme'
import PageTitle from 'components/PageTitle'
import InquiryForm from 'components/InquiryForm'
import OurPartners from 'components/OurPartners'
import { getPartners } from 'helpers/wordpress/wp-api'
import ContactHero from 'components/ContactHero'
import Contacts from 'components/Contacts'
import ContactInfoAlt from 'components/ContactInfoAlt'

const { publicRuntimeConfig } = getConfig()
const { CLOUDINARY_URL, DOMAIN_ROOT } = publicRuntimeConfig

const PrivacyPolicy = ({ canonical, t, i18n, partners }) => {
    // @TODO: Change SEO for contact page
    const seoData = {
        title: `${t('meta-data:contact-title')} | Merk & Merk`,
        description: t('meta-data:contact-description'),
        canonical: t('meta-data:contact-url'),
        openGraph: {
            title: `${t('meta-data:contact-title')} | Merk & Merk`,
            description: t('meta-data:contact-description'),
            url: t('meta-data:contact-url'),
            images: [
                {
                    url: `${CLOUDINARY_URL}/v1582632369/Static/sell-image_hace64.jpg`
                }
            ]
        },
        languageAlternates: [
            {
                hrefLang: 'en',
                href: `${DOMAIN_ROOT}/contact`
            },
            {
                hrefLang: 'de',
                href: `${DOMAIN_ROOT}/de/contact`
            }
        ]
    }

    const contactMembers = [
        {
            name: 'Mario Martinović',
            role: {
                roleEn: 'Sales',
                roleDe: 'Sales'
            },
            languages: 'DE, EN, CRO, ITA, ESP',
            phone: '+385 (0)91 346 7775',
            email: 'supermario@merkandmerk.com',
            image: '/images/board/mario-martinovic.png'
        },
        {
            name: 'Maik Heiligensetzer',
            role: {
                roleEn: 'Sales',
                roleDe: 'Sales'
            },
            languages: 'DE, EN',
            phone: '+49 1751500915',
            email: 'maik@merkandmerk.com',
            image: '/images/board/maik-heiligensetzer.png'
        },
        {
            name: 'Julian Merk',
            role: {
                roleEn: 'Founder & Director',
                roleDe: 'Gründer und Geschäftsführer'
            },
            languages: 'DE, EN, CRO',
            email: 'office@merkandmerk.com',
            image: '/images/board/julian-merk.png'
        }
    ]

    return (
        <main>
            <NextSeo {...seoData} />
            <div className="ContactTitle">
                <Box theme={layoutTheme} px={20} mt={[60, null, null, 140]} mb={80} maxWidth={1360} mx="auto">
                    <PageTitle isContact title={t('contact')} subtitle={t('get-in-touch-with-us')} titleTag="h1" />
                </Box>
            </div>

            <Box theme={layoutTheme}>
                <ContactHero />
            </Box>

            <Box theme={layoutTheme} mt={[10, null, null, 20]}>
                <Contacts data={contactMembers} />
            </Box>

            <Box theme={layoutTheme} variant="center1360" px={20}>
                <ContactInfoAlt />
            </Box>

            <Box theme={layoutTheme} px={20} mt={[10, null, null, 120]} maxWidth={1360} mx="auto">
                <PageTitle subtitle={t('our-partners')} titleTag="h3" />
            </Box>

            <OurPartners partners={partners} />

            <Box theme={layoutTheme} px={20} maxWidth={1360} mx="auto" mt={[10, null, null, 80]}>
                <BlockTitle title={t('our-location')} subtitle={t('our-location-text')} />
            </Box>

            <Box theme={layoutTheme} px={20} maxWidth={1360} mx="auto">
                <InquiryForm onPage />
            </Box>
        </main>
    )
}

PrivacyPolicy.getInitialProps = async ({ req: { i18n } = {} }) => {
    const partners = await getPartners()
    return {
        canonical: i18n ? i18n.getFixedT('en')('meta-data:newsletter-url') : undefined,
        namespacesRequired: ['common', 'meta-data'],
        partners: partners.partners.nodes
    }
}

PrivacyPolicy.propTypes = {
    canonical: PropTypes.string,
    i18n: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired,
    partners: PropTypes.arrayOf(),
    t: PropTypes.func.isRequired
}

PrivacyPolicy.defaultProps = {
    canonical: undefined,
    partners: null
}

export default withTranslation('common', 'meta-data')(PrivacyPolicy)
